export default __webpack_public_path__ + "static/media/chocolate.3cf10dd2.png";